import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LayoutActionLoadError } from '@shared/store/actions/layout.action';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { StockCollectionHistoryAction } from './stock-collection-history.actions';
import { StockCollectionHistoryService } from '../../service/stock-collection-history.service';

@Injectable()
export class StockCollectionHistoryEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private service: StockCollectionHistoryService
  ) {}

  loadStockCollectionHistoryListRequested$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StockCollectionHistoryAction.requestList),
      tap((action) =>
        this.logger.debug('@Effect Stock Collection History List Requested: ' + JSON.stringify(action.criteriaObj))
      ),
      switchMap((action) => {
        return this.service.getStockCollectionHistoryList(action.criteriaObj).pipe(
          map((data: any) => StockCollectionHistoryAction.responseList({ data })),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });
}
